/**
 * Set cursor to store
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {integer} value
 * @return {*}
 */
function setCursor(state, element, value) {
    return {
        ...state,
        [element]: {
            ...state[element],
            cursor: state.cursor === null ? null : (typeof value === 'object' && value !== null ? (state.cursor + value.add) : value),
        },
    }
}

/**
 * Set events full data to store
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {Object} data
 * @return {*}
 */
function eventsSetData(state, element, data) {
    return {
        ...state,
        [element]: {
            ...data,
        },
    }
}

/**
 * Set user total event count
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {Object} count
 * @return {*}
 */
function eventsSetTotalCount(state, element, count) {
    return {
        ...state,
        [element]: {
            ...state?.[element],
            totalCount: count,
        },
    }
}

/**
 * Set events full data to store
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {Object} data
 * @return {*}
 */
function eventsAppendData(state, element, data) {
    const appendedData = {
        ...state,
        [element]: {
            ...state?.[element],
            events: [
                ...data?.events,
            ],
        },
    }

    return appendedData
}

/**
 * Set events busy into store
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {boolean} busy
 * @return {*}
 */
function eventsSetBusy(state, element, busy) {
    return {
        ...state,
        [element]: {
            ...state[element],
            busy: busy,
        },
    }
}

/**
 * Set events markers to store
 *
 * @param {Object} state
 * @param {string} element  - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {Object} markers
 * @return {*}
 */
function eventsSetMarkers(state, element, markers) {
    return {
        ...state,
        [element]: {
            ...state[element],
            markers: markers,
        },
    }
}

/**
 * Set events is init load
 *
 * @param {Object} state
 * @param {string} element      - running, prev, events (from EVENTS_FRONT_ELEMENTS)
 * @param {boolean} initLoad
 * @return {*}
 */
function eventsSetInitLoad(state, element, initLoad) {
    return {
        ...state,
        [element]: {
            ...state[element],
            initLoad: initLoad,
        },
    }
}

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function (state = [], action) {
    switch (action.type) {
        case 'EVENTS_SET_CURSOR': return setCursor(state, action.element, action.cursor)
        case 'EVENTS_SET_DATA': return eventsSetData(state, action.element, action.data)
        case 'EVENTS_SET_TOTAL_COUNT': return eventsSetTotalCount(state, action.element, action.count)
        case 'EVENTS_APPEND_DATA': return eventsAppendData(state, action.element, action.data)
        case 'EVENTS_SET_BUSY': return eventsSetBusy(state, action.element, action.busy)
        case 'EVENTS_SET_MARKERS': return eventsSetMarkers(state, action.element, action.markers)
        case 'EVENTS_SET_INIT_LOAD': return eventsSetInitLoad(state, action.element, action.initLoad)
        default: return state
    }
}
